import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { TrackSelectorButton } from '../components/trackSelector/TrackSelector';
const activitiesSelector = state => state.activities;
const activityCountSelector = createSelector(activitiesSelector, activities => {
    let count = 0;
    Object.keys(activities).forEach(a => {
        if (activities[a].focusable) {
            count += 1;
        }
    });
    return count;
});
function TrackSelectorButtonComponent(props) {
    return (React.createElement(TrackSelectorButton, { count: props.activityCount, setModal: props.setModal, hideElements: props.hideElements }));
}
const mapStateToProps = state => ({
    activityCount: activityCountSelector(state),
    hideElements: state.scene.sceneSettings.hideElements,
});
const mapDispatchToProps = dispatch => ({
    setModal: modal => {
        dispatch({ type: 'SET_MODAL', modalType: modal });
        dispatch({ type: 'PUSH_PAUSE' });
    },
});
export default connect(mapStateToProps, mapDispatchToProps)(TrackSelectorButtonComponent);
